var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMemoryIcon = function SvgMemoryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9488_17399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.35867 11.633C4.92818 12.2025 4.92818 13.1259 4.35867 13.6954C3.78915 14.2649 2.86579 14.2649 2.29628 13.6954C1.72676 13.1259 1.72676 12.2025 2.29628 11.633C2.86579 11.0635 3.78916 11.0635 4.35867 11.633Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7891 12.4975C10.7891 11.6925 11.4416 11.0392 12.2474 11.0392C13.0532 11.0392 13.7057 11.6917 13.7057 12.4975C13.7057 13.3033 13.0532 13.9558 12.2474 13.9558C11.4449 13.9592 10.7924 13.3117 10.7891 12.5092C10.7891 12.505 10.7891 12.5017 10.7891 12.4975Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85281 6.46379C9.42232 7.0333 9.42232 7.95667 8.85281 8.52618C8.28329 9.0957 7.35993 9.0957 6.79042 8.52618C6.2209 7.95666 6.2209 7.0333 6.79042 6.46379C7.35993 5.89427 8.2833 5.89427 8.85281 6.46379Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7024 6.46379C18.2719 7.0333 18.2719 7.95667 17.7024 8.52618C17.1329 9.0957 16.2095 9.0957 15.64 8.52618C15.0705 7.95666 15.0705 7.0333 15.64 6.46379C16.2095 5.89427 17.1329 5.89427 17.7024 6.46379Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6569 8.54166L13.2402 11.4333",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.31641 11.5917L6.83307 8.55832",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2581 11.4333L8.81641 8.55832",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9488_17399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export { SvgMemoryIcon as ReactComponent };
export default __webpack_public_path__ + "memory-icon.svg";